import { createGlobalStyle } from 'styled-components';



const GlobalStyles = createGlobalStyle`
  body {
    color: var(--color-text);
    background:var(--color-background);
    text-rendering: optimizeSpeed;
  }
  p{
    @media only screen and (max-width: 768px) {
      font-size:16px;
    }
    @media only screen and (max-width: 468px) {
      font-size:14px;
    }
  }
  h1,h2,h3,h4,h5,h6,strong{
    color:var(--color-headingFont);
  }
  code{
    font-weight:normal ;
	  padding: .3em .5em;
	  border-radius: .3em;
    color: var(--color-primary);
	  background:var(--color-foreground);
}
  pre::-webkit-scrollbar{
    height: 25px;
    width: 25px;
  }
  pre::-webkit-scrollbar-thumb,
  pre[class*='language-']::-webkit-scrollbar-thumb {
    background: #80868b;
    background-clip: padding-box;
    border: 10px solid rgba(0,0,0,0);
    border-radius: 15px;
  }
  pre::-webkit-scrollbar-track,
  pre[class*='language-']::-webkit-scrollbar-track {
    background: rgba(0,0,0,0);
  }
  .headerLikeImage{
      border:none;
      margin-right:6px;
      scroll-margin-top: 2rem;
      outline:none;
      margin:0 0.5rem;
    }
  `;

export default GlobalStyles;



// h1{
    // font-size:2em;
    // line-height: 1.05;
    //   @media only screen and (max-width: 768px) {
    //     font-size:1.5em;
    //     line-height: 1.05;
    //   }
  // }
  // h2{
    // @media only screen and (max-width: 768px) {
    //   line-height: 1.15384615;
    // }
  // }
  // h3{
    // font-size:1.75em;
    // line-height: 1.25;
    // @media only screen and (max-width: 768px) {
    //   font-size:1.375em;
    //   line-height: 1.13636364;
    // }
  // }
  // h4{
    // @media only screen and (max-width: 768px) {
      // font-size:1em;
    //   line-height: 1.11111;
    // }
  // }